export const MAX_LENGTH = {
    ASSET: {
        NAME: 1000
    },
    AGREEMENT: {
        NAME: 255
    },
    ALLIANCE: {
        NAME: 255
    },
    AMENDMENT: {
        NAME: 255
    },
    BRIEF: {
        NAME: 1000
    },
    COMPANY: {
        NAME: 1000
    },
    CONSUMER_HEALTH: {
        NAME: 1000
    },
    CONTACT: {
        FIRST_NAME: 50,
        PREFERRED_NAME: 50,
        LAST_NAME: 50,
        FULL_NAME: 100,
        JOB: 100
    },
    CAMPAIGN: {
        NAME: 1000,
        DEPARTMENT: 100,
        PROVIDER: 1000
    },
    CONFERENCE: {
        NAME: 1000
    },
    CUSTOM_FILTER: {
        LABEL: 100
    },
    DEAL_STAGE: {
        NAME: 1000
    },
    DEAL_TYPE: {
        NAME: 1000,
        ID: 1000,
        DESCRIPTION: 200
    },
    DOCUMENT: {
        LABEL: 1000,
        FOLDER: 50,
        NOTE: 280
    },
    EMAIL: {
        LABEL: 1000,
        NOTE: 280
    },
    EVALUATION: {
        BLOCK_TITLE: 1000,
        SECTION_TITLE: 1000,
        TEMPLATE_NAME: 1000
    },
    EXTERNAL_LINK: {
        LABEL: 1000
    },
    LEAD: {
        NAME: 1000
    },
    LEAD_STATUS: {
        NAME: 1000
    },
    LEAD_BOARD: {
        NAME: 1000
    },
    MEETING: {
        TITLE: 100
    },
    OBLIGATION: {
        NAME: 255,
        OBLIGATION_ID: 80
    },
    PUBLICATION: {
        TITLE: 1000
    },
    PFCV: {
        LABEL: 1000
    },
    TAG: { LABEL: 50 },
    TASK: {
        LABEL: 140,
        COMPLETED_MESSAGE: 500,
        ACTIVE_MESSAGE: 500,
        DESCRIPTION: 500
    },
    TECHNOLOGY: {
        NAME: 1000
    },
    TEMPLATE: {
        LEAD_SUMMARY_TITLE: 1000,
        REPORT: { TITLE: 100, DESCRIPTION: 160 }
    }
};
